import { defineStore } from 'pinia';

export const getProdutoNovo = function() {
  return {
    produto: '',
    lote: '',
    peso: '',
    data: '',
    local: '',
    desc: '',
    midia: [],
  };
};

export const useSacStore = defineStore('sac', {
  state: () => ({
    etapaAtiva: 1,
    showSuccessForm: false,
    produtos: [getProdutoNovo()],
    nome: '',
    cpf: '',
    email: '',
    email_confirmation: '',
    telefone: '',
    telefone2: '',
    cep: '',
    endereco: '',
    bairro: '',
    numero: '',
    completo: '',
    estado: '',
    cidade: '',
    termos: false,
  }),
  actions: {
    adicionaNovoProduto() {
      this.produtos.push(getProdutoNovo());
    },
    removerProduto(index) {
      this.produtos.splice(index, 1);
    },
    irParaEtapa(etapa) {
      this.etapaAtiva = etapa;
    },
    pegaFormData() {
      const formData = new FormData();

      formData.append('nome', this.nome);
      formData.append('cpf', this.cpf);
      formData.append('email', this.email);
      formData.append('telefone', this.telefone);
      formData.append('telefone2', this.telefone2);
      formData.append('cep', this.cep);
      formData.append('endereco', this.endereco);
      formData.append('bairro', this.bairro);
      formData.append('numero', this.numero);
      formData.append('completo', this.completo);
      formData.append('estado', this.estado);
      formData.append('cidade', this.cidade);
      formData.append('termos', this.termos ? 1 : 0);

      this.produtos.forEach((produto, index) => {
        formData.append(`produtos[${index}][produto]`, produto.produto);
        formData.append(`produtos[${index}][lote]`, produto.lote);
        formData.append(`produtos[${index}][peso]`, produto.peso);
        formData.append(`produtos[${index}][data]`, produto.data);
        formData.append(`produtos[${index}][local]`, produto.local);
        formData.append(`produtos[${index}][desc]`, produto.desc);

        if (produto.midia.length > 0) {
          produto.midia.forEach((midia, midiaIndex) => {
            formData.append(`produtos_${index}_${midiaIndex}`, midia);
          });
        }
      });

      return formData;
    }
  },
});
